import React from 'react';
import { Box, Heading, Text, SimpleGrid, Icon } from '@chakra-ui/react';
import { FaWallet, FaCreditCard, FaExchangeAlt } from 'react-icons/fa';

const HowToBuy = () => {
  return (
    <Box w="100%" px={{ base: '4', md: '10', lg: '20' }} py="10" textAlign="center" bg="#222222" color="white" marginBottom="-1.5em">

      <Box style={{display:'flex', gap:'35px'}} flexDirection={{ base: 'column', md: 'row' }}>
        <video
          autoPlay
          muted
          loop
          style={{ margin:'0 auto', marginTop:'-2.5em', marginBottom:'2em', border:'4px solid white'}}
        >
          <source src="/seiya1.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <video
          autoPlay
          muted
          loop
          style={{ margin:'0 auto', marginTop:'-2.5em', marginBottom:'2em', border:'4px solid white'}}
        >
          <source src="/seiya2.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>   

        <video
          autoPlay
          muted
          loop
          style={{ margin:'0 auto', marginTop:'-2.5em', marginBottom:'2em', border:'4px solid white'}}
        >
          <source src="/seiya3.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>     
      </Box>

      <Heading as="h2" fontSize={{ base: '5xl', md: '8xl' }} mb="4" textTransform="uppercase" fontFamily="'Fugaz One', sans-serif">
        How to Buy
      </Heading>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing="10">
        <Box
          bg="red"
          p="6"
          borderRadius="md"
          textAlign="center"
          boxShadow="lg"
          _hover={{ bg: '#570000' }}
        >
          <Icon as={FaWallet} w={10} h={10} mb="4" color="white" />
          <Heading as="h3" fontSize="xl" mb="2" textTransform="uppercase" fontFamily="'Fugaz One', sans-serif" style={{textShadow:'2px 2px 2px black'}}>
            Fund Your Wallet with SEI
            </Heading>
        </Box>

        <Box
          bg="red"
          p="6"
          borderRadius="md"
          textAlign="center"
          boxShadow="lg"
          _hover={{ bg: '#570000' }}
        >
          <Icon as={FaCreditCard} w={10} h={10} mb="4" color="white" />
          <Heading as="h3" fontSize="xl" mb="2" textTransform="uppercase" fontFamily="'Fugaz One', sans-serif" style={{textShadow:'2px 2px 2px black'}}>
            Visit <a href="https://dragonswap.app/swap?outputCurrency=0x000000000000000000000000000" target='_blank' style={{textDecoration:'underline'}}>DRAGONSWAP</a>
            </Heading>
        </Box>

        <Box
          bg="red"
          p="6"
          borderRadius="md"
          textAlign="center"
          boxShadow="lg"
          _hover={{ bg: '#570000' }}
        >
          <Icon as={FaExchangeAlt} w={10} h={10} mb="4" color="white" />
          <Heading as="h3" fontSize="xl" mb="2" textTransform="uppercase" fontFamily="'Fugaz One', sans-serif" style={{textShadow:'2px 2px 2px black'}}>
            Swap SEI for $Seiya</Heading>
        </Box>
      </SimpleGrid>
    </Box>
  );
};

export default HowToBuy;
